var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComentar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0416 23.6266L21.0815 17.6665H12.1666V5.62484H29.1666V17.6665H27.0417L27.0416 23.6266ZM13.5833 16.2498H21.6683L25.6249 20.2065L25.625 16.2498H27.7499V7.0415H13.5833V16.2498ZM8.9183 13.4165H10.7499V11.9998H8.33154L4.37492 15.9565L4.37483 11.9998H2.24992V2.08317H17.1249V4.20817H18.5416V0.666504H0.833252V13.4165H2.95817L2.95825 19.3766L8.9183 13.4165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComentar);
export default __webpack_public_path__ + "static/media/comentar.60556026d3847cafa17a8881704bc7c4.svg";
export { ForwardRef as ReactComponent };